export default __webpack_public_path__ + "static/productbg2-c81a0908c5eab511f45f2d377ee4d770.png";